import React from 'react';

const colorMap = {
  blue: { bg: '#eff6ff', color: '#1d4ed8' },
  green: { bg: '#f0fdf4', color: '#15803d' },
  orange: { bg: '#fff7ed', color: '#c2410c' },
  purple: { bg: '#faf5ff', color: '#7c3aed' },
  red: { bg: '#fef2f2', color: '#b91c1c' },
  yellow: { bg: '#fefce8', color: '#a16207' },
  teal: { bg: '#f0fdfa', color: '#0f766e' },
  pink: { bg: '#fdf2f8', color: '#be185d' },
};

const StatCard = ({ icon, value, label, color = 'blue', change, subtitle }) => {
  const c = colorMap[color] || colorMap.blue;
  return (
    <div className="stat-card h-100">
      <div className="stat-icon" style={{ background: c.bg, color: c.color }}>
        {icon}
      </div>
      <div className="stat-info">
        <h3>{value ?? '—'}</h3>
        <p>{label}</p>
        {change && (
          <span className={`stat-change ${change > 0 ? 'up' : 'down'}`}>
            {change > 0 ? '↑' : '↓'} {Math.abs(change)}%
          </span>
        )}
        {subtitle && <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>{subtitle}</div>}
      </div>
    </div>
  );
};

export default StatCard;
